document.addEventListener('DOMContentLoaded', function () {

  const items = document.querySelectorAll('.wifi-faq-item');

  items.forEach(item => {

    const summary = item.querySelector('.wifi-faq-question');
    const answer = item.querySelector('.wifi-faq-answer');

    summary.addEventListener('click', function (e) {

      e.preventDefault();

      const isOpen = item.hasAttribute('open');

      // Close all other FAQs
      items.forEach(otherItem => {

        if (otherItem !== item && otherItem.hasAttribute('open')) {

          const otherAnswer = otherItem.querySelector('.wifi-faq-answer');

          otherAnswer.style.height =
            otherAnswer.scrollHeight + 'px';

          requestAnimationFrame(() => {
            otherAnswer.style.height = '0px';
          });

          setTimeout(() => {
            otherItem.removeAttribute('open');
          }, 350);

        }

      });

      // Close current
      if (isOpen) {

        answer.style.height = answer.scrollHeight + 'px';

        requestAnimationFrame(() => {
          answer.style.height = '0px';
        });

        setTimeout(() => {
          item.removeAttribute('open');
        }, 350);

      }

      // Open current
      else {

        item.setAttribute('open', '');

        answer.style.height = '0px';

        requestAnimationFrame(() => {
          answer.style.height =
            answer.scrollHeight + 'px';
        });

        answer.addEventListener('transitionend', function handler() {

          answer.style.height = 'auto';

          answer.removeEventListener(
            'transitionend',
            handler
          );

        });

      }

    });

  });

});

// Product Pickup Button

document.addEventListener('DOMContentLoaded', function(){

  const btn = document.getElementById('pickupPopupBtn');
  const modal = document.getElementById('pickupModal');
  const closeBtn = document.querySelector('.pickup-close');

  btn.addEventListener('click', function(){
    modal.classList.add('active');
  });

  closeBtn.addEventListener('click', function(){
    modal.classList.remove('active');
  });

  modal.addEventListener('click', function(e){
    if(e.target === modal){
      modal.classList.remove('active');
    }
  });

});

// Home Hero Slider

document.addEventListener('DOMContentLoaded', function () {

  new Swiper('.wifiHeroSlider', {
  loop: true,

  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },

  autoHeight: true,

  autoplay: {
    delay: 500000,
    disableOnInteraction: false
  },

  navigation: {
    nextEl: '.shop-category-next',
    prevEl: '.shop-category-prev',
  },

  pagination: {
    el: '.wifiHeroSlider .swiper-pagination',
    clickable: true
  },

  speed: 1000
});

new Swiper('.shop-by-category-grid.swiper', {
  slidesPerView: 4,
  spaceBetween: 20,

  navigation: {
    nextEl: '.shop-category-next',
    prevEl: '.shop-category-prev',
  },

  pagination: {
    el: '.shop-by-category-grid .swiper-pagination',
    clickable: true
  },

  breakpoints: {
    0: {
      slidesPerView: 2
    },
    600: {
      slidesPerView: 2
    },
    1024: {
      slidesPerView: 3
    },
    1200: {
      slidesPerView: 4
    }
  }
});

// Best Selling  Slider

new Swiper('.best-selling-grid.swiper', {
  slidesPerView: 4,
  spaceBetween: 20,

  navigation: {
    nextEl: '.shop-category-next',
    prevEl: '.shop-category-prev',
  },

  pagination: {
    el: '.best-selling-grid .swiper-pagination',
    clickable: true
  },

  breakpoints: {
    0: {
      slidesPerView: 2
    },
    600: {
      slidesPerView: 2
    },
    1024: {
      slidesPerView: 3
    },
    1200: {
      slidesPerView: 4
    }
  }
});

});


// Description 3 Li Show

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 500) return;

  const description = document.querySelector(".product-main-description");
  if (!description) return;

  const list = description.querySelector("ul");
  if (!list) return;

  const items = list.querySelectorAll("li");

  if (items.length <= 3) return;

  let hiddenItems = [];

  items.forEach((item, index) => {
    if (index >= 3) {
      hiddenItems.push(item);
    }
  });

  const wrapper = document.createElement("div");
  wrapper.className = "read-more-content";

  hiddenItems.forEach(item => wrapper.appendChild(item));

  list.appendChild(wrapper);

  const button = document.createElement("button");
  button.className = "read-more-btn";
  button.textContent = "Read More";

  description.appendChild(button);

  button.addEventListener("click", function () {
    wrapper.classList.toggle("active");

    if (wrapper.classList.contains("active")) {
      wrapper.style.maxHeight = wrapper.scrollHeight + "px";
      button.textContent = "Read Less";
    } else {
      wrapper.style.maxHeight = "0px";
      button.textContent = "Read More";
    }
  });
});

// Key Feature & Perfect For mobile Accordian

document.addEventListener("DOMContentLoaded", function () {

  if (window.innerWidth > 500) return;

  document.querySelectorAll(".wifi-key-features").forEach(section => {

    const trigger = section.querySelector(".accordion-trigger");
    const content = section.querySelector(".wifi-features-grid");

    if (!trigger || !content) return;

    content.style.maxHeight = "0px";

    trigger.addEventListener("click", function () {

      const isOpen = section.classList.contains("active");

      if (isOpen) {
        section.classList.remove("active");
        content.style.maxHeight = "0px";
      } else {
        section.classList.add("active");
        content.style.maxHeight = content.scrollHeight + "px";
      }

    });

  });

});

// FAQ Accordian mobile

document.addEventListener("DOMContentLoaded", function () {

  if (window.innerWidth > 500) return;

  document.querySelectorAll(".wifi-faq-wrapper").forEach(section => {

    const trigger = section.querySelector(".accordion-trigger");
    const content = section.querySelector(".wifi-faq-content");

    if (!trigger || !content) return;

    content.style.maxHeight = "0px";

    trigger.addEventListener("click", function () {

      const isOpen = section.classList.contains("active");

      if (isOpen) {
        section.classList.remove("active");
        content.style.maxHeight = "0px";
      } else {
        section.classList.add("active");
        content.style.maxHeight = content.scrollHeight + "px";
      }

    });

  });

});

/* Description Accrodian Mobile */

// document.addEventListener("DOMContentLoaded", function () {

//   if (window.innerWidth > 500) return;

//   document.querySelectorAll(".custom-feature-section").forEach(section => {

//     const trigger = section.querySelector(".accordion-trigger");
//     const content = section.querySelector(".features-discription-grid");

//     if (!trigger || !content) return;

//     content.style.maxHeight = "0px";

//     trigger.addEventListener("click", function () {

//       const isOpen = section.classList.contains("active");

//       if (isOpen) {
//         section.classList.remove("active");
//         content.style.maxHeight = "0px";
//       } else {
//         section.classList.add("active");
//         content.style.maxHeight = content.scrollHeight + "px";
//       }

//     });

//   });

// });

document.addEventListener("DOMContentLoaded", function () {

  if (window.innerWidth > 500) return;

  document.querySelectorAll(".rich-text").forEach(function(section){

    const heading = section.querySelector(".rich-text__heading");
    const content = section.querySelector(".rich-text__text");

    if (!heading || !content) return;

    // Initial state
    content.style.maxHeight = "0px";
    content.style.overflow = "hidden";
    content.style.transition = "max-height .35s ease";

    heading.style.cursor = "pointer";

    heading.addEventListener("click", function(){

      if(section.classList.contains("accordion-open")){

        section.classList.remove("accordion-open");
        content.style.maxHeight = "0px";

      }else{

        section.classList.add("accordion-open");
        content.style.maxHeight = content.scrollHeight + "px";

      }

    });

  });

});

// Collection Page Accordian

document.addEventListener("DOMContentLoaded", () => {

  if (window.innerWidth > 767) return;

  const cards = document.querySelectorAll(".category-group-card");

  cards.forEach(card => {

    const trigger = card.querySelector(".accordion-trigger");
    const content = card.querySelector(".category-group-list");

    trigger.addEventListener("click", (e) => {

      // View All link par click ho to accordion na khule
      if (e.target.closest(".category-group-viewall")) return;

      const isActive = card.classList.contains("active");

      cards.forEach(item => {
        item.classList.remove("active");
        item.querySelector(".category-group-list").style.maxHeight = null;
      });

      if (!isActive) {
        card.classList.add("active");
        content.style.maxHeight = content.scrollHeight + "px";
      }

    });

  });

});